<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">

  <div class="legend">
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#7b3294'"></div>
      <span>0 to 20%</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#c2a5cf'"></div>
      <span>21% to 40%</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#f7f7f7'"></div>
      <span>41% to 60%</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#a6dba0'"></div>
      <span>61% to 80%</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#008837'"></div>
      <span>81% to 100%</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#444444'"></div>
      <span>Not Covered</span>
    </div>

  </div>
</tgrid-layer-header>
